import React, { createContext, useContext, useState, useEffect } from 'react'
import { DataService } from '../services/DataService'
import { MetadataService } from '../services/MetadataService'

const PodcastContext = createContext()

export const PodcastProvider = ({ children }) => {
  const [episodes, setEpisodes] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [currentTrack, setCurrentTrack] = useState(null)
  const [isAudioWidgetExpanded, setIsAudioWidgetExpanded] = useState(false)
  
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true)
        setError(null)
        
        // Initialiser le service de métadonnées en parallèle
        const [episodeData] = await Promise.all([
          DataService.loadAllEpisodes(),
          MetadataService.initialize()
        ])
        
        if (episodeData.length === 0) {
          throw new Error('Aucun épisode n\'a pu être chargé')
        }
        
        setEpisodes(episodeData)
        
        // Log de debug en développement uniquement
        if (import.meta.env.DEV) {
          console.log('✅ Données chargées avec succès:', episodeData.length, 'épisodes')
          DataService.logDataStructure(episodeData)
        }
      } catch (err) {
        console.error('❌ Erreur lors du chargement des données:', err)
        setError(err.message || 'Impossible de charger les données des épisodes')
      } finally {
        setLoading(false)
      }
    }

    loadData()
  }, [])

  const contextValue = {
    episodes,
    loading,
    error,
    currentTrack,
    setCurrentTrack,
    isAudioWidgetExpanded,
    setIsAudioWidgetExpanded
  }
  
  return (
    <PodcastContext.Provider value={contextValue}>
      {children}
    </PodcastContext.Provider>
  )
}

export const usePodcastContext = () => {
  const context = useContext(PodcastContext)
  if (!context) {
    throw new Error('usePodcastContext doit être utilisé dans un PodcastProvider')
  }
  return context
} 